import {synthesesConstants} from "./syntheses.constants";
import {synthesesService} from "./syntheses.service";
import {toastHelper} from "../../utils/toast-helper";
import Constants from "../../utils/constants";
import history from "../../utils/history";
import {helper} from "../../utils/helper";

export const synthesesActions = {
    fetchInterventionPDF,
    fetchSynthese
};

function fetchInterventionPDF(interventionId, interventionDate) {
    return dispatch => {
        dispatch(request());

        synthesesService.fetchInterventionPDF(interventionId);
    };

    function request() {
        return {type: synthesesConstants.SYNTHESE_FICHE_INTERVENTION_FETCH_REQUEST}
    }

    function failure(error) {
        return {type: synthesesConstants.SYNTHESE_FICHE_INTERVENTION_FETCH_FAILURE, error}
    }
}

function fetchSynthese(values) {
    return dispatch => {
        const p = synthesesService.fetchSynthese(values);
        if (!p || typeof p.then !== 'function') {
            return Promise.resolve();
        }
        // Classeur xlsx : l'API répond 400 / 403 / 404 en JSON — on le montre au lieu d'un rejet silencieux.
        // La promesse renvoyée (résolue après le téléchargement ou l'erreur) laisse l'appelant tenir l'état
        // « en cours » du bouton jusqu'au retour de l'API — le bilan xlsx peut prendre plusieurs secondes.
        return p.catch((error) => toastHelper.handleError(error, "Oops, l'export a échoué."));
    };

}